import axios from 'axios'
import qs from 'qs'
import Router from './router.js'
import Vue from 'vue'
// const baseURL = "http://192.168.0.145:7000";
// const baseURL = "http://192.168.15.154:7000";
// const baseURL = "http://192.168.0.159:8000";
// const baseURL = "http://192.168.15.154:7001";
// const baseURL = "http://39.105.16.191:7000";
// const baseURL = "http://39.105.212.20:7000";
// const baseURL = "http://tpeixun.teblcu.com:5144";
//  const baseURL = "https://tpeixun.teblcu.com:7001";
//  const baseURL = "http://192.168.0.143:7000";
const baseURL = "https://data.eblcu.com/";
// const baseURL = "http://localhost:7001/";

 // const baseURL = "https://peixun.teblcu.com:7001";
 
//
const studentUrl = "https://class.eblcu.com";
// const studentUrl = "https://peixun.teblcu.com";
// const newsURL = studentUrl+"/student/content.html";
// const newsURL = "https://www.eblcu.com/news_detail";
const newsURL = "https://www.eblcu.com/app/anonymous/web/toNewsDetail";
// const blogURL = "https://www.eblcu.com/blog_detail";
const blogURL = "https://www.eblcu.com/app/anonymous/web/toBlogDetail";
const openclassURL = "https://www.eblcu.com/app/anonymous/web/toOpenClassDetail";
const commodityURL = studentUrl+"/student/course_outline.html";
const yhCommodityURL = "https://www.eblcu.com/course_detail";
const teacherURL = studentUrl+"/student/jsxq.html";
const findPwd = studentUrl+"/student/zhmm.html";

// const newsURL = "https://peixun.teblcu.com/ksxx_word.html";
// const commodityURL = "https://peixun.teblcu.com/course_outline.html";
// const teacherURL = "https://peixun.teblcu.com/jsxq.html";
// const newsURL = "http://192.168.0.145:8011/ksxx_word.html";
// const commodityURL = "http://192.168.0.145:8011/course_outline.html";
// const teacherURL = "http://192.168.0.145:8011/jsxq.html";

axios.defaults.timeout = 50000;                         //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头
axios.defaults.baseURL = baseURL;   //配置接口地址

// axios.defaults.baseURL = 'http://192.168.15.152:7000';
//
// //POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {
    //在发送请求之前做某件事
    config.headers.Authentication = localStorage.getItem("token");
    return config;
},(error) =>{
    console.log('错误的传参')
    return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    //对响应数据做些事
    if(!res.data.success){
        // authentication
      if(res.headers.authentication) {
        localStorage.setItem("token",res.headers.authentication);
      }
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    if(error.response.status == 401) {
        Router.push("/login");
        return ;
    }
    console.log('网络异常')
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params, contentType, header, responseType) {
    return new Promise((resolve, reject) => {
        if(header) {
            for(let i in header) {
                axios.defaults.headers.post[header[i].key] = header[i].value;
            }

        }
        if(contentType === "json") {
            axios.defaults.headers.post['Content-Type'] = 'application/json';
        }
        if(contentType === "form") {
            axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
            params = qs.stringify(params);
        }
      if(responseType == 'blob'){
        axios.post(url,params,{responseType: responseType})
            .then(response => {
              resolve(response);
            }, err => {
              reject(err);
            })
            .catch((error) => {
              reject(error)
            })
      } else {
        axios.post(url, params)
            .then(response => {
              resolve(response);
            }, err => {
              reject(err);
            })
            .catch((error) => {
              reject(error)
            })
      }

    })
}
////返回一个Promise(发送get请求)
export function fetchGet(url,param, responseType) {

    return new Promise((resolve, reject) => {
        if(responseType == 'blob') {
            axios.get(url,{responseType: responseType},{params: param})
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
                .catch((error) => {
                    reject(error)
                })
        } else {
            axios.get(url,{params: param})
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
                .catch((error) => {
                    reject(error)
                })
        }

    })
}
export default {
    fetchPost,
    fetchGet,
    baseURL,
    commodityURL,
    yhCommodityURL,
    newsURL,
    teacherURL,
    findPwd,
    blogURL,
    openclassURL

}
